import React, { ChangeEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  memberDetailActions,
  selectLoginHistory,
  selectLoginHistoryLoading,
} from 'features/member/reducer/memberDetailSlice';

import { FIRST_PAGE_INDEX } from 'constants/common';
import { getUtcUSFormatDateWithTime } from 'modules/utils/time';

import AccordionBox from 'components/memberdetail/detail/AccordionBox';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';

import { LoginHistory as LoginHistoryType } from 'types/member';
import { TableCell } from 'types/common/table';

import * as S from './LoginHistory.styled';

interface Props {
  userId: string;
}

const LoginHistory = ({ userId }: Props) => {
  const dispatch = useDispatch();

  const [historyPageIndex, setHistoryPageIndex] = useState<number>(FIRST_PAGE_INDEX);

  const {
    items: loginHistoryInformation,
    totalPages: loginHistoryTotalPages,
    totalItems: loginHistoryTotalItems,
  } = useSelector(selectLoginHistory);

  const loginHistoryLoading = useSelector(selectLoginHistoryLoading);

  const onChangeDisplay = (event: ChangeEvent, expanded: boolean, name: string) => {
    const isLoginHistory = name === 'loginHistory';

    if (expanded && isLoginHistory) {
      dispatch(memberDetailActions.getLoginHistory({ userId }));
    }
  };

  const onChangeLoginHistoryPage = (pageIndex: number) => {
    setHistoryPageIndex(pageIndex);
    dispatch(memberDetailActions.getLoginHistory({ userId, page: pageIndex }));
  };

  const loginHistoryColumns: TableCell<LoginHistoryType>[] = [
    {
      align: 'center',
      name: 'Seq',
      width: '10%',
      key: 'seq',
      render: ({ seq }: LoginHistoryType) => seq,
    },
    {
      align: 'center',
      name: 'Login Date',
      key: 'loginDate',
      render: ({ loginDate }: LoginHistoryType) => getUtcUSFormatDateWithTime(loginDate, true),
    },
  ];

  return (
    <AccordionBox
      title={'Login History'}
      margin={'15px 0 0 0'}
      name={'loginHistory'}
      onChangeDisplay={onChangeDisplay}
    >
      <DataTableLayout
        maxHeight={'300px'}
        currentPageIndex={historyPageIndex}
        totalPages={loginHistoryTotalPages}
        onChangePage={onChangeLoginHistoryPage}
        customTitleComponent={<S.TotalCount>total {loginHistoryTotalItems}</S.TotalCount>}
        showPagination
      >
        <DataTableHeader header={loginHistoryColumns} />
        <NewDataTableBody
          loading={loginHistoryLoading}
          dataList={loginHistoryInformation}
          columns={loginHistoryColumns}
        />
      </DataTableLayout>
    </AccordionBox>
  );
};

export default LoginHistory;
